module.exports = __webpack_public_path__ + "static/media/0218_Medium.76a0a407.jpg";